// extracted by mini-css-extract-plugin
module.exports = {"historyStats":"HistoryStats_historyStats__10Tot","value":"HistoryStats_value__3H9sk","label":"HistoryStats_label__1L0VS","avg":"HistoryStats_avg__W-L5r"};